/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_TitleInputs */

const vi_tea_package_title = /** @type {(inputs: Tea_Package_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng gói chè`)
};

/**

* @param {Tea_Package_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_title = /** @type {((inputs?: Tea_Package_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_title(inputs)
});